import { Div, Span, reactive, not, if as _if } from 'alkali'
import Icon from 'components/Icon'
import * as del from 'icons/delete-1.svg'

import './CollapsibleSection.scss'

export const CollapsibleSection = Div('.collapsible-section', {
	created(properties) {
		let open = reactive(typeof properties.open == 'boolean' ? properties.open : (properties.open ?? true))
		const toggleable = properties.toggleable ?? true
		const removable = properties.removable
		properties.content = [
			Div('.header', {
				classes: {
					toggleable
				},
				onclick() {
					if (toggleable.valueOf()) {
						open.put(!open.valueOf())
					}
				}
			}, [
				properties.header,
				_if(removable, [Icon('.remove', {
					icon: del,
					onclick: properties.onRemove
				})]),
				_if(toggleable, [Span('.twisty', {
					classes: {
						'expander-icon-s': open,
						'expander-icon-e': not(open),
					},
					content: '➤'
				})]),
			]),
			Div('.body', [properties.body]),
		]
		properties.classes = {
			open,
			...(properties.classes || {})
		}
	},
})
